<template>
  <div class="referral">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.editReferral') }}
        </h3>
      </div>
      <div class="box-body">
        <form-referral />
      </div>
    </div>
  </div>
</template>

<script>
import FormReferral from './Form'
export default {
  name: 'Edit',
  components: { FormReferral },
  metaInfo () {
    return {
      title: this.$t('string.editReferral'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
